<div class="footercontent">
    <div class="footer-contenedor-secundario">
        <div class="row rowaux">
            <div class="col-6 col-sm-5 col-md-4">
                <div class="contenedor-img-footer">     
                    <div class="contenedor-img-centrado">
                        <div class="img-centrado">
                            <img class="brandIMG" src="assets/png/BlancoSVG.svg" alt="Grupo Centro">
                        </div>
                    </div>            
                </div>           
            </div>
            <div class="col-6 col-sm-7 col-md-4">
                <div class="row rowaux">
                    <div class="contenedor-contacta-nosotros contactaStyle">
                        <div class="copyrigth">
                            <div class="texto-copyrigth">
                                <!--<div class="img-centrado logoVisible">
                                    <img class="imgLogo" src="assets/png/logoATT.png">
                                </div>-->
                                <h4 class="alineado">
                                    <a class="address" target="_blank" href="https://www.google.com/maps/place/Radio+Centro/@-17.3904801,-66.1595785,15z/data=!4m5!3m4!1s0x0:0x715c6546cbe641f2!8m2!3d-17.3904801!4d-66.1595785">
                                    <fa-icon [icon]="faMapMarkerAlt"></fa-icon> Av Ayacucho, Cochabamba 
                                    </a>
                                </h4>
                                <mat-toolbar-row>
                                    <ul class="social-networks">
                                        <li>
                                          <a class="social-link" target="_blank"  href="https://www.facebook.com/grupocentro05">
                                            <i class="fa fa-facebook" title="Facebook"></i>
                                          </a>
                                        </li>
                                        
                                        <li>
                                            <a class="social-link" target="_blank"  href="https://www.instagram.com/grupocentro_bolivia/?hl=es-la">
                                                <i class="fa fa-instagram" title="Instagram"></i>
                                            </a>
                                        </li>
                                       
                                        <li>
                                          <a class="social-link" target="_blank"  href="https://www.youtube.com/channel/UCFNqVABZsfh-AQwst0F2T7Q">
                                            <i class="fa fa-youtube-play" title="YouTube" aria-hidden="true"></i>
                                          </a>
                                        </li>
                                    </ul>      
                                </mat-toolbar-row>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="col-12 col-sm-3 logoInvicible">
                <div class="img-centrado  centre">
                    <img class="imgLogoTwo" src="assets/png/logoATT.png">
                </div>
            </div>-->
            <!--Cuando este el logo el col-md-4 podria pasar a ser col-md-12-->
            <div class="col-12 col-md-4">
                <div class="row rowaux">
                    <div class="contenedor-contacta-nosotros">
                        <div class="copyrigth">
                            <div class="texto-copyrigth">                                         
                                <h4 class="h4Text">© 2020 Radio Centro. Reservados todos los derechos, Empresa de telecomunicacion Radial</h4> 
                             </div>   
                         </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>     
    
</div>